import { hookstate } from "@hookstate/core";

export type PurchasesFilterState = {
  query?: string;
};

const DEFAULT_FILTER_STATE: PurchasesFilterState = {};

export const purchasesFilterStore =
  hookstate<PurchasesFilterState>(DEFAULT_FILTER_STATE);
